import Service from "../service";
import AuthService from "../authService"

const Group = {
    onGetGroup() {
        return Service.get("/getBookGroup");
    },
    getEbook(payload) {
        return AuthService.get("/getEbook?groupid=" + payload.groupid + "&page=" + payload.page + "&filterid=" + payload.filterid);

    },
    getEresearch(payload) {
        return AuthService.get("/getEresearch?groupid=" + payload.groupid + "&page=" + payload.page + "&filterid=" + payload.filterid);

    },
    saveFavoriteBook(bookid) {
        return AuthService.post("/saveFavoriteBook", {
            bookid: bookid
        });
    },
    deleteFavoriteBook(bookid) {
        return AuthService.post("/deleteFavoriteBook", {
            bookid: bookid
        });
    },
    // getFavoriteBook(payload) {
    //     return AuthService.get("/getFavoriteBook?page=" + payload.page + "&groupid=" + payload.groupid);
    // },
    filterBook(groupid) {
        return AuthService.get('/filterBook?groupid=' + groupid);
    },
    getBookBanner() {
        return Service.get('/bookbanner');
    },
    getFlipbook(bookid) {
        return AuthService.get('/getFlipbook?bookid=' + bookid);
    }

};

export default Group;